import {useForm, SubmitHandler} from "react-hook-form";
import {router} from "@inertiajs/core";
import {usePage} from "@inertiajs/react";
import {
    Card,
    CardHeader,
    CardTitle,
    CardContent,
    CardFooter,
    CardDescription,
} from "@/components/ui/card";
import {Button} from "@/components/ui/button";
import {
    Form,
    FormField,
    FormItem,
    FormLabel,
    FormControl,
    FormMessage,
} from "@/components/ui/form";
import {Input} from "@/components/ui/input";
import {Checkbox} from "@/components/ui/checkbox";

type LoginFormData = {
    username: string;
    password: string;
    remember_me: boolean;
};

export default function Login() {
    const {translations, errors = {}, form_values = {}} = usePage().props as any;
    const t = translations || {};

    const form = useForm<LoginFormData>({
        defaultValues: {
            username: form_values.username || "",
            password: "",
            remember_me: form_values.remember_me || false,
        },
    });

    const onSubmit: SubmitHandler<LoginFormData> = (data) => {
        router.post("/sign_in", {
            username: data.username,
            password: data.password,
            remember_me: data.remember_me ? "1" : "0",
        });
    };

    return (
        <div className="bg-muted min-h-screen flex items-center justify-center p-6 md:p-10">
            <div className="w-full max-w-md flex flex-col items-center gap-6">

                <header className="text-center">
                    <h1 className="text-3xl font-semibold tracking-tight">
                        {t.company_name ?? "Ordinacija Kardašević"}
                    </h1>
                    <p className="text-sm text-muted-foreground mt-1">
                        {t.app_subtitle ?? "Aplikacija za zakazivanje"}
                    </p>
                </header>
                <Card className="w-full">
                    <CardHeader>
                        <CardTitle>{t.welcome_back ?? "Dobrodošli nazad"}</CardTitle>
                    </CardHeader>

                    <CardContent>
                        <Form {...form}>
                            <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-6">
                                <FormField
                                    control={form.control}
                                    name="username"
                                    render={({field}) => (
                                        <FormItem className="flex flex-col gap-1">
                                            <FormLabel>{t.username ?? "Korisničko ime"}</FormLabel>
                                            <FormControl>
                                                <Input {...field}
                                                       placeholder={t.username_placeholder ?? "Enter username"}/>
                                            </FormControl>
                                            <FormMessage/>
                                        </FormItem>
                                    )}
                                />

                                <FormField
                                    control={form.control}
                                    name="password"
                                    render={({field}) => (
                                        <FormItem className="flex flex-col gap-1">
                                            <FormLabel>{t.password ?? "Password"}</FormLabel>
                                            <FormControl>
                                                <Input {...field} type="password"
                                                       placeholder={t.password_placeholder ?? "Lozinka"}/>
                                            </FormControl>
                                            <FormMessage/>
                                        </FormItem>
                                    )}
                                />

                                <FormField
                                    control={form.control}
                                    name="remember_me"
                                    render={({field}) => (
                                        <FormItem className="flex items-center gap-2">
                                            <FormControl>
                                                <Checkbox checked={field.value}
                                                          onCheckedChange={(checked) => field.onChange(!!checked)}/>
                                            </FormControl>
                                            <FormLabel className="m-0">{t.remember_me ?? "Zapamti me"}</FormLabel>
                                        </FormItem>
                                    )}
                                />

                                {errors.login && (
                                    <div className="text-sm text-red-600">{errors.login}</div>
                                )}

                                <Button type="submit">{t.login_button ?? "Prijavi se"}</Button>
                            </form>
                        </Form>
                    </CardContent>

                    <CardFooter>
                        <CardDescription>{t.forgot_password ?? "Zaboravili ste lozinku? Kontaktirajte podršku"}</CardDescription>
                    </CardFooter>
                </Card>
            </div>
        </div>
    );
}
